import React from 'react';
import { View, StyleSheet } from 'react-native';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import LinearGradient from 'utils/packages/linearGradient';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import RadioButton from 'design-system/RadioButton';
import { linearGradientEnd, linearGradientStart, rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import { corporateEventGradientColorMap } from '../colors';
import { corporateEventLabelMap } from '../types';
const CorporateEventFilterRow = ({ type, onPress, selected }) => {
    const colors = useColors();
    return (<TouchableHighlight hoverOnLight activeOpacity={1} onPress={onPress} underlayColor={colors.background.underlay}>
      <View style={styles.container}>
        <RadioButton type="multiple" isChecked={selected}/>
        <View style={styles.main}>
          <Text Text-16>{corporateEventLabelMap[type]}</Text>
        </View>
        <LinearGradient end={linearGradientEnd} start={linearGradientStart} style={styles.linearGradient} colors={colors.gradients[corporateEventGradientColorMap[type]].colors}/>
        <Spacer w={16}/>
      </View>
    </TouchableHighlight>);
};
export default CorporateEventFilterRow;
const styles = StyleSheet.create({
    container: {
        padding: rem(16),
        flexDirection: 'row',
    },
    linearGradient: {
        width: rem(2),
        borderRadius: rem(10),
    },
    main: {
        flex: 1,
        justifyContent: 'center',
        paddingHorizontal: rem(16),
    },
});
